exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".tags-container {\n  margin-top: 20px;\n  height: calc(100vh - 80px);\n  overflow: auto;\n  padding: 0 10px; }\n  .tags-container .custom-table {\n    margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/tags/index.scss
// module id = 1463
// module chunks = 0